var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"letter-test"},[_c('div',{staticClass:"wrapper"},[_c('iframe',{ref:"preview",attrs:{"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }